export const LEAD_FORM_EVENT = "open-lead-form";

export const openLeadForm = (source = "website") => {
  window.dispatchEvent(new CustomEvent(LEAD_FORM_EVENT, { detail: { source } }));
};
